import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function Login() {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { loginWithGoogle } = useAuth();
  const navigate = useNavigate();

  async function handleGoogleLogin() {
    try {
      setError('');
      setLoading(true);
      await loginWithGoogle();
      navigate('/');
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="max-w-md w-full space-y-8 bg-white shadow-2xl rounded-2xl p-10 border border-gray-200 relative" style={{ boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.10), 0 1.5px 6px 0 rgba(0, 191, 174, 0.08)' }}>
        <div className="flex flex-col items-center">
          <div className="mb-4">
            {/* Gaming icon or logo */}
            <span className="text-5xl drop-shadow-lg">🎮</span>
          </div>
          <h2 className="text-center text-4xl font-extrabold text-gray-900 mb-2">
            Welcome to <span className="text-[#00bfae]">NexGENGaming</span>
          </h2>
          <p className="text-center text-lg text-gray-500 mb-6 font-medium">
            Sign in to unlock the next generation of gaming shopping.
          </p>
        </div>
        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4 text-center" role="alert">
            <span className="block sm:inline">{error}</span>
          </div>
        )}
        <div>
          <button
            onClick={handleGoogleLogin}
            disabled={loading}
            className="group relative w-full flex justify-center items-center py-3 px-4 border-2 border-[#00bfae] text-lg font-bold rounded-xl text-white bg-[#00bfae] hover:bg-[#00ffe7] hover:text-gray-900 shadow-md transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#00bfae]"
            style={{ boxShadow: '0 4px 16px 0 rgba(0, 191, 174, 0.10)' }}
          >
            <span className="mr-2 text-2xl">🔑</span>
            {loading ? 'Signing in...' : 'Sign in with Google'}
          </button>
        </div>
        <div className="mt-8 text-center text-gray-400 text-xs">
          &copy; {new Date().getFullYear()} NexGENGaming. All rights reserved.
        </div>
        {/* Subtle 3D accent */}
        <div className="absolute -bottom-4 left-1/2 transform -translate-x-1/2 w-2/3 h-4 bg-[#00bfae]/20 rounded-b-2xl blur-sm" style={{ filter: 'blur(6px)' }} />
      </div>
    </div>
  );
} 